module.exports = __webpack_public_path__ + "img/Header-Option-community.ccc79a8f.jpg";